import React from 'react';

import { BaseIconProps } from './';

export const CheckmarkRoundedOutline = ({ fill }: BaseIconProps) => {
  return (
    <g transform="translate(-704,-139)">
      <rect
        id="Rectangle"
        width="1012.0596"
        height="1012.0596"
        fill="none"
        stroke={fill}
        strokeWidth="67.9404"
        x="739.38428"
        y="174.38417"
        rx="181.30873"
      />
      <path
        id="ic_chevron_left_24px"
        d="m 1031.5854,643.51801 -58.51291,66.75759 194.61541,189.23521 341.9457,-376.11143 -65.1275,-60.3547 -283.4572,308.88515 z"
        fill="#1875f0"
        strokeWidth={fill}
      />
    </g>
  );
};
